import type { WixClient } from '@wix/sdk/client';
import React from 'react';

export type GetWixClientPromise = () => Promise<WixClient>;

export const useGetWixClientPromise = (
  instance: string,
  existingWixClientGetter?: GetWixClientPromise
) => {
  const getWixClientPromise = React.useMemo(() => {
    let wixClientPromise: ReturnType<GetWixClientPromise>;
    return () => {
      if (wixClientPromise) {
        return wixClientPromise;
      }

      wixClientPromise = import(
        /* webpackChunkName: "wix-ricos-sdk-client" */ '@wix/sdk/client'
      ).then(clientSdk => {
        return clientSdk.createClient({
          auth: {
            getAuthHeaders: () => ({ headers: { Authorization: instance } }),
          },
        });
      });
      return wixClientPromise;
    };
  }, [instance]);

  return existingWixClientGetter
    ? { getWixClientPromise: existingWixClientGetter }
    : { getWixClientPromise };
};
